<template>
    <!--<seccion-datos :titulo="datos" :botonGuardar="factoadmin"  @cambios="guardar()" >
            <div class="form-group">
                <label for="nombre_completo">{{ $t('general.nombrecompleto') }}</label>
                <input :disabled="!factoadmin || essoporteelusuario" type="text" class="form-control nombre_completo dato" v-model='nombre' id="nombre_completo" placeholder="Nombre completo" >
            </div>
            <div class="form-group">
                <label for="nif">NIF/NIE</label>
                <input :disabled="!factoadmin || essoporteelusuario" type="text" class="form-control nif dato" v-model='nif' id="nif" placeholder="NIF/NIE" >
            </div>
            <div class="form-group">
                <label for="nif">{{ $t('general.direcciondeemail') }}</label>
                <input :disabled="!factoadmin || essoporteelusuario" type="text" class="form-control email dato" v-model='email' id="email" placeholder="e-mail personal, usado para recuperación contraseña" autocomplete=false >
            </div>
    </seccion-datos>-->
    <div class="card card-primary">
        <div class="card-header">
            
                <h3 class="card-title">{{ datos }}</h3>
                <div class="card-tools">
                    <button type="button" v-if="factoadmin && !essoporteelusuario" @click="guardar(id)" class="btn btn-block btn-default btn-xs">
      
        {{ $t('general.guardar') }}
    </button>
                </div>
        </div>
        <div class="card-body">
 
                <div class="form-group">
                <label for="nombre_completo">{{ $t('general.nombrecompleto') }}</label>
                <input :disabled="!factoadmin || essoporteelusuario" type="text" class="form-control nombre_completo dato" v-model='nombre' id="nombre_completo" placeholder="Nombre completo" >
            </div>
            <div class="form-group">
                <label for="nif">NIF/NIE</label>
                <input :disabled="!factoadmin || essoporteelusuario" type="text" class="form-control nif dato" v-model='nif' id="nif" placeholder="NIF/NIE" >
            </div>
            <div class="form-group">
                <label for="nif">{{ $t('general.direcciondeemail') }}</label>
                <input :disabled="!factoadmin || essoporteelusuario" type="text" class="form-control email dato" v-model='email' id="email" placeholder="e-mail personal, usado para recuperación contraseña" autocomplete=false >
            </div>
                            
        </div>
        
    
    </div>
    
</template>
<script>
import { PwgsApi } from '../../../../../services/PwgsApi';
export default {
    props: ['usuario','id','factoadmin','essoporteelusuario'],
    data() {
        return {
            nombre: '',
            nif: '',
            email: '', 
            datos:this.$t("general.datos"),
        }
    },
    methods: {
        cargardatos() {
            console.log('factoadmin',this.$props.factoadmin);
           // this.$store.dispatch('cambiarCargando', true);
            this.nombre = this.usuario.nombre_completo;
            this.nif = this.usuario.nif;
            this.email = this.usuario.email;
            //this.$store.dispatch('cambiarCargando', false);
            this.datos = this.$t("general.datos");

        },
        async guardar() {
            try {
                const api = new PwgsApi;
                const subidadatos = { nombre_completo: this.nombre, nif: this.nif, email: this.email };
                this.$store.dispatch('cambiarGuardando', true);
                await api.put('usuarios/' + this.usuario.id, subidadatos);
                this.$parent.$parent.obtenerUsuario(this.usuario.id);
                this.$store.dispatch('cambiarGuardando', false);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
            }
            catch (error) {
                this.$parent.$parent.obtenerUsuario(this.usuario.id);
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async crear() {
            try {
                const api = new PwgsApi;
                const subidadatos = { nombre: this.nombre, nif: this.nif, email: this.email };
                await api.put('usuarios', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });

            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        }, 
    },
    watch: {
        usuario() {
            this.cargardatos();
        }
    },
    mounted() {
        this.cargardatos();
    },
}
</script>